import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';
import styled from 'styled-components';
import { hideVisually } from 'polished';

import { Button } from './Buttons';

const StyledCarPartsSearch = styled.div`
  margin: 0;
`;

const Form = styled.form`
  display: flex;
  flex-wrap: wrap;
`;

const Label = styled.label`
  margin: 0;
  flex: 1;
  font-size: 1.125rem;
`;

const LabelText = styled.div`
  ${hideVisually()};
`;

const SearchField = styled.input`
  padding: 15px 20px;
  width: 100%;
`;

const ValidationMessage = styled.div`
  color: ${p => p.theme.colors.error};
  font-size: 0.875rem;
  margin: 10px 0;
  flex: 0 0 100%;
`;

class CarPartsSearch extends Component {
  state = {
    search: '',
    validation: '',
    loading: false
  };

  static propTypes = {
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    type: PropTypes.string
  };

  handleSearchInputChange = event => {
    this.setState({
      search: event.target.value.toLowerCase(),
      validation: '',
      loading: false
    });
  };

  handleSearchSubmit = event => {
    event.preventDefault();

    if (!this.state.search) {
      this.setState({
        validation: 'Vennligst skriv inn et søkeord!'
      });

      return null;
    }

    const query = qs.parse(this.props.location.search, {
      arrayFormat: 'bracket'
    });

    return this.props.history.push({
      pathname: '/bildeler/',
      search: qs.stringify(
        {
          ...query,
          [this.props.type || 'sok']: this.state.search
        },
        { arrayFormat: 'bracket' }
      )
    });
  };

  render() {
    return (
      <StyledCarPartsSearch>
        <Form onSubmit={this.handleSearchSubmit}>
          <Label>
            <LabelText>{this.props.label}</LabelText>

            <SearchField
              value={this.state.search}
              onChange={this.handleSearchInputChange}
              placeholder={this.props.placeholder}
            />
          </Label>

          <Button>{this.props.buttonText}</Button>
        </Form>

        {this.state.validation && (
          <ValidationMessage>{this.state.validation}</ValidationMessage>
        )}
      </StyledCarPartsSearch>
    );
  }
}

export default withRouter(CarPartsSearch);
